export function ArrowLeftBackIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M2.19385 8.46999C2.19432 8.47046 2.19479 8.47093 2.19526 8.4714C2.19515 8.47129 2.19538 8.47152 2.19526 8.4714L7.5286 13.8047C7.78895 14.0651 8.21106 14.0651 8.4714 13.8047C8.73175 13.5444 8.73175 13.1223 8.4714 12.8619L4.27614 8.66667H13.3333C13.7015 8.66667 14 8.36819 14 8C14 7.63181 13.7015 7.33333 13.3333 7.33333H4.27614L8.4714 3.13807C8.73175 2.87772 8.73175 2.45561 8.4714 2.19526C8.21106 1.93491 7.78895 1.93491 7.5286 2.19526L2.19526 7.5286L2.19385 7.53001C2.07404 7.65054 2 7.81662 2 8C2 8.09039 2.01799 8.17659 2.05059 8.25519C2.05206 8.25875 2.05357 8.26231 2.05511 8.26585C2.08727 8.3399 2.13352 8.4093 2.19385 8.46999Z"
        fill="currentColor"
      />
    </svg>
  );
}
